import * as AppDefinitions from '../App.d'
import { Account } from '../../../back-end/utilities/apiDefinitions'

const getAccountByID = (appState: AppDefinitions.AppState, accountID: string | undefined): Account | undefined =>
	accountID ? (appState.accounts || []).find((a) => a.accountID === accountID) : undefined

// The account the user is currently acting as. Note custom:currentAccountId is a Cognito attribute read
// once at sign-in, so it can lag an account switch while the API token already carries the new account -
// prefer getAccountByID with the owning ID of whatever you're gating when you have it.
const getCurrentAccount = (appState: AppDefinitions.AppState): Account | undefined => {
	// One reducer branch assigns accounts straight from the API response without defaulting to [], so don't
	// assume the array is there.
	const accounts = appState.accounts || []
	const matched = getAccountByID(appState, appState.authState?.attributes?.['custom:currentAccountId'])

	return matched || (accounts.length === 1 ? accounts[0] : undefined)
}

// Account-level entitlement for the SubSync Stripe Bank Feed, granted per customer during rollout (there is
// no admin UI yet - see back-end/scripts/migrate-subsync-account-bankfeeds-flag.sql). Enforced server-side
// too, so this only decides whether to show the settings UI.
// Pass the accountID that owns the record being configured (e.g. AccountStripeOrg.accountID); it falls back
// to the current account only when there's nothing more specific to go on.
const accountCanUseBankFeeds = (appState: AppDefinitions.AppState, accountID?: string): boolean =>
	!!(getAccountByID(appState, accountID) || getCurrentAccount(appState))?.canUseBankFeeds

export { getAccountByID, getCurrentAccount, accountCanUseBankFeeds }
